(function () {

    'use strict';

    eclipseApp.controller('prepaidRefillAutoBalanceCtrl', ['$scope', '$rootScope', '$state', '$filter', '$previousState', 'prepaidAutoRefillInfoService', 'prepaidRegisteredCCInfoService', 'prepaidRefillTaxCalculationService', 'prepaidPlanInfoService', 'prepaidUserInfoService', 'prepaidRefillAutoBalanceService', 'uteEndpoint', '$http', 'httpService', 'uteModal', 'uteLocale', 'util', 'uteSemafoneService', 'retrievePrepaidPlanInfo', 'retrievePrepaidUserInfo', '$sessionStorage', function ($scope, $rootScope, $state, $filter, $previousState,  prepaidAutoRefillInfoService,prepaidRegisteredCCInfoService, prepaidRefillTaxCalculationService, prepaidPlanInfoService,prepaidUserInfoService, prepaidRefillAutoBalanceService, uteEndpoint, $http, httpService, uteModal, uteLocale, util, uteSemafoneService, retrievePrepaidPlanInfo, retrievePrepaidUserInfo, $sessionStorage) {


    prepaidAutoRefillInfoService.setStopAutoPaymentResponse('');

        $scope.$extend({


            autoRefillSubscribed : 'true',
            language : uteLocale.language,
            name : prepaidUserInfoService.getFirstName() + ' ' + prepaidUserInfoService.getLastName(),
            expiryDate : prepaidRegisteredCCInfoService.getMonth(),
            cardNumber : prepaidRegisteredCCInfoService.getTokenizedCCNumber(),
            ctn : prepaidUserInfoService.getCTN(),
            email : prepaidUserInfoService.getEmailAddress(),
            //prepaidAutoRefillInfoService.setStopAutoPaymentResponse('');
            billingAddress:prepaidUserInfoService.getBillingAddress(),
            flag : prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag,
            $storage : $sessionStorage,

            init : function () {
              if(prepaidUserInfoService.getCTN() === null || prepaidUserInfoService.getCTN() === '' || prepaidUserInfoService.getBAN() === null || prepaidUserInfoService.getBAN() === '') {
                prepaidUserInfoService.setCTN($scope.$storage.selectedCTN);
                prepaidUserInfoService.setBAN($scope.$storage.selectedBAN);
                $scope.ctn = prepaidUserInfoService.getCTN();
              }
              if(prepaidAutoRefillInfoService.getAutoPayPlanInfo().registeredFlag || prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag || prepaidAutoRefillInfoService.getAutoRefillBalanceEligibility()){

                var promise = httpService.send('v1/refill/autorefill/balance/amounts',{
                 accountNumber: prepaidUserInfoService.getBAN(),
                 planSOC: prepaidPlanInfoService.getAirTimePlanSoc(),
                 autoMSFEligibility: prepaidAutoRefillInfoService.getAutoPayPlanInfo().registeredFlag
               });
                promise.then(
                    function (result) {
                        if (result.data.error || result.data.status == 'Failed') {
                            $scope.autoRefillBalanceError = true;
                        } else {
                            $scope.valueList = result.data.thresholdAmounts;
                            $scope.refillAmountList = result.data.rechargeAmounts;
                            $scope.selectedRefillAmount = $scope.refillAmountList[0];
                            $scope.data = result.data;
                            $scope.refillBalance =result.data.thresholdAmounts[0];
                            //alert('Before Coming from Review Page');
                            //if(angular.isDefined($previousState.get().state.name) && $previousState.get().state.name !== '' && $previousState.get().state.name !== null && $previousState.get().state.name === 'myAccount.prepaidRefill.autoRefillBalance-review'){
                            if(angular.isDefined($rootScope.previousState) && $rootScope.previousState !== null && $rootScope.previousState !== '' && $rootScope.previousState.name === 'myAccount.prepaidRefill.autoRefillBalance-review'){
                                //alert('Coming from Review Page');
                                $scope.selectedRefillAmount.duration = prepaidRefillAutoBalanceService.getRefillValue().duration;
                                $scope.selectedRefillAmount.rechargeAmount = prepaidRefillAutoBalanceService.getRefillValue().rechargeAmount;
                                $scope.refillBalance = prepaidRefillAutoBalanceService.getThresholdValue();
                            }
                        }
                    },
                   function (reason) {
                        $scope.autoRefillBalanceError = true;
                   }
               );

               } else {

                $scope.autoRefillBalanceEligibilityError = true;
              }
              $scope.isAutoPayReview = true ;
              $scope.stopAutoPaymentNotifier = '';
              $scope.CreditCardRegistrationStatus = prepaidRegisteredCCInfoService.getCreditCardRegistrationStatus();

            },

            fetchRefillBalance : function () {

                 var promise = httpService.send('v1/refill/autorefill/submit/autopayment',{
                    accountNumber : prepaidUserInfoService.getBAN(),
                    ctn   : prepaidUserInfoService.getCTN(),
                    autoMSFEligibility : false,
                    autoEXLBEligibility : true,
                    refillAmount  : $scope.refillAmount.rechargeAmount,
                    thresholdAmount : $scope.refillBalance
                 });
                 promise.then(
                     function (item) {
                        if (item.data.error || item.data.status == 'Failed') {
                        $scope.submitRefillBalanceError = true;
                     } else {
                         $scope.isAutoPayReview = false ;
                        }
                     },
                      function (reason) {
                       $scope.autoRefillBalanceError = true;
                      }
                 );
            },

            updateRefillBalanceService : function () {
                var promise = httpService.send(
               'v1/refill/autorefill/scheduled/details', // TODO : Need to change
               {
                     accountNumber: prepaidUserInfoService.getBAN(),
                     ctn: prepaidUserInfoService.getCTN(),
                     language: $scope.language
               });

             promise.then(
               function (result) {
                 if (result.data.error || result.data.error != '') {
                   $scope.autoRefillSubscriptionInfoError = true;
                   console.log('AutoRefillSubscriptionInfo Error');
                 } else {
                   console.log('Got AutoRefillSubscriptionInfo Successfully');
                   $scope.autoRefillSubscriptionInfo = result.data;
                   console.log('$scope.autoRefillSubscriptionInfo :: '+$scope.autoRefillSubscriptionInfo);
                   prepaidAutoRefillInfoService.setAutoPayPlanInfo($scope.autoRefillSubscriptionInfo.autoPayPlan);
                   prepaidAutoRefillInfoService.setAutoRefillBalanceInfo($scope.autoRefillSubscriptionInfo.autoRefillBalance);
                   var $translate = $filter('translate');
                   var $currency = $filter('currency');
                   if(prepaidAutoRefillInfoService.getAutoPayPlanInfo().registeredFlag){
                     var $date = $filter('date');
                     var scheduledRefillDate = new Date($scope.autoRefillSubscriptionInfo.autoPayPlan.rechargeDate) ;
                     $scope.autoRefillSubscriptionInfo.autoPayPlan.rechargeDate = scheduledRefillDate;
                     prepaidAutoRefillInfoService.setAutoPayPlanSubContent('<p class="fido-tick-icon">' + $translate('global.label.nextPaymentOf') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoPayPlanInfo().rechargeAmount) + '</p><p>' + $translate('global.label.autoPayPlanBridge') + ' ' + $date(scheduledRefillDate,'MMMM dd, yyyy') + '</p>');
                     prepaidAutoRefillInfoService.setAutoPayPlanContentClass('tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-2');
                     if(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag){
                       prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('<p class="fido-tick-icon-secondary">' + $translate('global.label.add') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().rechargeAmount) + ' ' + $translate('global.label.autoRefillBalanceBridge') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().balanceThreshold) + '</p>');
                       prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-9');
                     }else{
                       prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('');
                       prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5');
                     }
                   }else{
                     prepaidAutoRefillInfoService.setAutoPayPlanSubContent('');
                     prepaidAutoRefillInfoService.setAutoPayPlanContentClass('tab pp-refill-margin-top-1-5');
                     if(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag){
                       prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('<p class="fido-tick-icon-secondary">' + $translate('global.label.add') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().rechargeAmount) + ' ' + $translate('global.label.autoRefillBalanceBridge') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().balanceThreshold) + '</p>');
                       prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-9');
                     }else{
                       prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('');
                       prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5');
                     }
                   }
                   prepaidAutoRefillInfoService.setStopAutoPaymentResponse(true);
                   $state.go('myAccount.prepaidRefill');
                 }
               },
               function (reason) {
                 $scope.autoRefillSubscriptionInfoError = true;
               }
             );
            },

            backToAcc : function () {
                $state.go('myAccount.overview');
            },

            cancel : function(){
              //$scope.clearSharedPropertyService();
              $state.go('myAccount.prepaidWLDashboard' , {'accountNumber': prepaidUserInfoService.getBAN(), 'subscriberNo': prepaidUserInfoService.getCTN()});
            },

            calculateTaxAmount : function(){
                var promise = httpService.send('v1/refill/autorefill/tax/amount',{
                accountNumber: prepaidUserInfoService.getBAN(),
                ctn: prepaidUserInfoService.getCTN(),
                refillAmount: $scope.selectedRefillAmount.rechargeAmount
              });
               promise.then(
                 function (detail) {
                 if (detail.data.error || detail.data.status == 'Failed') {
                 $scope.prepaidAutoRefillBalanceError = true;

                 } else {
                          prepaidRefillAutoBalanceService.setThresholdValue($scope.refillBalance);
                          prepaidRefillAutoBalanceService.setRefillValue($scope.selectedRefillAmount);
                          prepaidRefillTaxCalculationService.setGST(detail.data.gst);
                          prepaidRefillTaxCalculationService.setPST(detail.data.pst);
                          prepaidRefillTaxCalculationService.setTotal(detail.data.totalAmount);
                          $state.go('myAccount.prepaidRefill.autoRefillBalance-review');
                          }
                 },
                 function (reason) {
                    $scope.prepaidAutoRefillBalanceError = true;
                 }
               );
            },

            retrieveCreditCardRegistrationInfo : function (accountNumber, subscriberNumber) {
                      var promise = httpService.send(
                        'v1/wireless/prepaid/creditcard/retrieve/ccinfo', // TODO : Need to change
                        {
                        accountNumber: accountNumber,
                        ctn: subscriberNumber
                        });

                      promise.then(
                        function (result) {
                          if (result.data.error || result.data.status == 'Failed') {
                            $scope.creditCardRegistrationInfoError = true;
                          } else {
                            //alert('Got userInfo Successfully');
                            $scope.creditCardRegistrationInfo = result.data;
                            if($scope.creditCardRegistrationInfo.registrationStatus){
                              //prepaidRegisteredCCInfoService.setCardScheme($scope.creditCardRegistrationInfo.creditCardInfo.cardType);
                              prepaidRegisteredCCInfoService.setTokenizedCCNumber($scope.creditCardRegistrationInfo.creditCardInfo.creditCardNo);
                              prepaidRegisteredCCInfoService.setMonth($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                              prepaidRegisteredCCInfoService.setYear($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                            }
                            prepaidRegisteredCCInfoService.setCreditCardRegistrationStatus($scope.creditCardRegistrationInfo.registrationStatus);
                          }
                        },
                        function (reason) {
                          $scope.creditCardRegistrationInfoError = true;
                        }
                      );
                    },

            stopAutoPayPlanPayment : function () {
                  /*var modalConfig = {
                    templateUrl: 'modules/my-account/prepaid/dashboard/refill/stop-auto-payments.html',
                    controller: function ($scope, $modalInstance) {
                      $scope.ok = function () {
                        $modalInstance.close();
                      };

                      $scope.cancel = function () {
                        $modalInstance.dismiss('cancel');
                      };
                    },
                    ok: function () {
                         var promise = httpService.send('v1/refill/autorefill/stop/autopayment',{
                         accountNumber: prepaidUserInfoService.getBAN(),
                         ctn   : prepaidUserInfoService.getCTN(),
                         cancelExLBStatus : true,
                         cancelMsfStatus : false


                       });
                        promise.then(
                           function (choice) {
                           if (choice.data.error || choice.data.status == 'Failed') {
                           $scope.stopAutoPaymentError = true;
                           } else {
                           $scope.updateRefillBalanceService();
                           }
                           },
                        function (reason) {
                            prepaidAutoRefillInfoService.setStopAutoPaymentResponse(false);
                            $scope.stopAutoPaymentError = true;
                            $state.go('myAccount.prepaidRefill');
                            }
                        );
                  },
                  cancel: function () {

                  }
                  };*/

                  // show modal
                  //uteModal.open(modalConfig);
                  uteModal.open({
                    templateUrl: 'modules/my-account/prepaid/dashboard/refill/stop-auto-payments.html',
                    /*controller: function ($scope, $modalInstance) {
                      $scope.ok = function () {
                        $modalInstance.close();
                      };

                      $scope.cancel = function () {
                        $modalInstance.dismiss('cancel');
                      };
                    },*/
                    ok: function () {
                         var promise = httpService.send('v1/refill/autorefill/stop/autopayment',{
                         accountNumber: prepaidUserInfoService.getBAN(),
                         ctn   : prepaidUserInfoService.getCTN(),
                         cancelExLBStatus : true,
                         cancelMsfStatus : false


                       });
                        promise.then(
                           function (choice) {
                           if (choice.data.error || choice.data.status == 'Failed') {
                           $scope.stopAutoPaymentError = true;
                           } else {
                           $scope.updateRefillBalanceService();
                           }
                           },
                        function (reason) {
                            prepaidAutoRefillInfoService.setStopAutoPaymentResponse(false);
                            $scope.stopAutoPaymentError = true;
                            $state.go('myAccount.prepaidRefill');
                            }
                        );
                  },
                  cancel: function () {

                  }
                  });
                },

            relaunchPage : function () {
              $scope.init();
              if(prepaidRefillTaxCalculationService.getGST() !== null && prepaidRefillTaxCalculationService.getGST() != ''){
                  $scope.gst = prepaidRefillTaxCalculationService.getGST();
                  $scope.pst = prepaidRefillTaxCalculationService.getPST();
                  $scope.totalAmount = prepaidRefillTaxCalculationService.getTotal();
                  $scope.refillAmount = prepaidRefillAutoBalanceService.getRefillValue();
                  $scope.refillBalance = prepaidRefillAutoBalanceService.getThresholdValue();
              }
            }

        });
            $scope.today = new Date();
            $scope.firstMonth = 1;
            $scope.setRange = function(min, max) {
                var months = [];
                for (var i = min; i <= max; i++) months.push(i);
                return months;
            };
            $scope.payNowRule = {
                amount: {
                    type: 'number',
                    min: 0.01
                },
                ccNumber: {
                    pattern: '((([0-9]{4}[ -]?){4})|(([0-9]{4}[ -]?)([0-9]{6}[ -]?)([0-9]{5})))'
                },
                expMonth: {
                    type: 'number',
                    min: 1,
                    max: 12
                },
                expYear: {
                    type: 'number',
                    min: 2015,
                    max: 2025
                },
                cvv: {
                    type: 'text',
                    minlength: 3,
                    maxlength: 4,
                    pattern: '^[0-9]{3,4}$'
                },
                ccName: {
                    pattern: 'VISA|MASTER|AMEX'
                },
                ccTnc: {}
            };

            $scope.payNow = {};
            $scope.payment = {};
            var selfCardType = '';

            $scope.registerCreditCard = function(form) {
                util.validateFormOnSubmit(form);
                if (!form.$valid || ($scope.payNow.expYear == $scope.today.getFullYear() && $scope.payNow.expMonth <= $scope.today.getMonth())) {
                    if (uteSemafoneService.getMaskedCardNumber() == null || uteSemafoneService.getMaskedCardNumber() == '') {
                        $scope.isNotValidCard = true;
                    }
                    return;
                }

                if (uteSemafoneService.getCardScheme() == 'VISA') {
                    selfCardType = 'VISA';
                } else if (uteSemafoneService.getCardScheme() == 'AMEX') {
                    selfCardType = 'AMEX';
                } else if (uteSemafoneService.getCardScheme() == 'MASTERCARD') {
                    selfCardType = 'MASTERCARD';
                }

                var cvvLength = document.getElementById('cvv').value.length;
                $scope.maskedCardNumber = uteSemafoneService.getMaskedCardNumber();
                $scope.payment.maskedToken = uteSemafoneService.getToken();
                $scope.payment.ccType = uteSemafoneService.getCardScheme();

                if ($scope.payment.ccType == 'VISA') {
                    $scope.cardType = 'ute-creditcards visa';
                }
                if ($scope.payment.ccType == 'AMEX') {
                    $scope.cardType = 'ute-creditcards amex';
                }
                if ($scope.payment.ccType == 'MASTERCARD') {
                    $scope.cardType = 'ute-creditcards master';
                }

                if ($scope.payment.maskedToken == null || $scope.payment.maskedToken == '') {
                    $scope.isNotValidCard = true;
                    alert('The card number is invalid');
                } else {
                    console.log('$scope.payment ready', $scope.payment);

                }

                var promise = httpService.send(
                    'v1/wireless/prepaid/creditcard/register', {
                        'CreditCardInfo.ccType': $scope.payment.ccType,
                        'CreditCardInfo.ccNumber': $scope.payment.maskedToken,
                        'CreditCardInfo.ccExpiryMonth': $scope.payNow.expMonth,
                        'CreditCardInfo.ccExpiryYear': $scope.payNow.expYear,
                        'CreditCardInfo.securityCode': $scope.payNow.cvv,
                    ctn:  prepaidUserInfoService.getCTN(),
                    accountNumber: prepaidUserInfoService.getBAN()
                });

                promise.then(
                    function(result) {
                        if (result.data.error || result.data.status == 'Failed') {
                            $scope.registerCardInfoError = true;
                        } else {
                           /* prepaidRegisteredCCInfoService.setCreditCardRegistrationStatus(true);
                            prepaidRegisteredCCInfoService.setMonth($scope.payNow.expMonth + '-' + $scope.payNow.expYear);
                            prepaidRegisteredCCInfoService.setTokenizedCCNumber($scope.payment.maskedToken);*/
                            $scope.retrieveCreditCardRegistrationInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN());
                            $scope.calculateTaxAmount();
                        }
                    },
                    function(reason) {
                        $scope.registerCardInfoError = true;
                    }
                );

            };
    /**
    * tabs data for ui tabs directive
    * @type {{heading: string, subheading: string, route: string}[]}
    */

     $scope.tabData = [
          {
            heading: 'wireless.label.setUpAutoPayPlan',
            route: 'myAccount.prepaidRefill.autoPayPlan',
            autoRefillSubscribed: 'false',
            content: prepaidAutoRefillInfoService.getAutoPayPlanSubContent(),
            class:'tab pp-refill-margin-top-1-5'
          },
          {
            heading: 'wireless.label.setUpAutoRefillBalance',
            route: 'myAccount.prepaidRefill.autoRefillBalance',
            autoRefillSubscribed: 'true',
            content: prepaidAutoRefillInfoService.getAutoRefillBalanceSubContent(),
            class: prepaidAutoRefillInfoService.getAutoRefillBalanceContentClass(),
            active: true
          },
          {
            heading: 'wireless.label.oneTimeRefill',
            route: 'myAccount.prepaidRefill.oneTimeRefill',
            class:'tab pp-refill-margin-top-1-5'

          },
          {
            heading: 'wireless.label.redeemVoucher',
            route: 'myAccount.prepaidRefill.redeemVoucher',
            class:'tab pp-refill-margin-top-1-5'
          }
        ];

        $scope.mobileTabData = [
          {
            heading: 'wireless.label.setUpAutoRefillBalance',
            route: 'myAccount.prepaidRefill.autoRefillBalance',
            autoRefillSubscribed: 'true',
            content: prepaidAutoRefillInfoService.getAutoRefillBalanceSubContent(),
            class:'tab pp-refill-margin-top-1-5',
            active: true
          }
        ];


        $scope.relaunchPage();


     }]);

    })();
